import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { DropdownList, Icons } from '@/js/libs/ui/src/V2';
import { getTestId } from '../helpers';
import { ToolbarItem } from '../styled';
import { PlaceholdersDropdownItem } from './PlaceholdersDropdownItem';
export const PlaceholdersDropdown = ({ placeholders, onPlaceholderClick, disabled, dataTestId }) => {
    const handlePlaceholderClick = useCallbackRef((placeholder) => {
        onPlaceholderClick?.(placeholder);
    });
    return (_jsx(DropdownList, { zIndex: 1000, buttonComponent: _jsx(ToolbarItem, { type: 'button', disabled: disabled, "data-testid": getTestId('toolbar-placeholders', dataTestId), children: _jsx(Icons.More, { size: 20 }) }), "data-testid": getTestId('placeholders-dropdown', dataTestId), children: placeholders.map((placeholder) => (_jsx(PlaceholdersDropdownItem, { item: placeholder, onClick: handlePlaceholderClick }, placeholder))) }));
};
